var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionAlertWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.429,
    height: 24.099,
    viewBox: "0 0 27.429 24.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(1.536 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94268",
    "data-name": "Path 94268",
    d: "M12.512,5.468,2.64,21.948a2.331,2.331,0,0,0,1.993,3.5H24.377a2.331,2.331,0,0,0,1.993-3.5L16.5,5.468a2.331,2.331,0,0,0-3.986,0Z",
    transform: "translate(-2.328 -4.346)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94269",
    "data-name": "Path 94269",
    d: "M18,13.5v4.662",
    transform: "translate(-5.823 -6.387)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94270",
    "data-name": "Path 94270",
    d: "M18,25.5h0",
    transform: "translate(-5.823 -9.063)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionAlertWhite);
export default __webpack_public_path__ + "static/media/AccordionAlertWhite.9e38a00c2b440ceef65618bba8204cff.svg";
export { ForwardRef as ReactComponent };